/**
 * Timetastic
 * Footer component
 */
import React from "react"
import { Link } from "gatsby"

// Helpers
import { trackCta } from "src/helpers"

// Components
// import Logo from "src/components/logo"
// import NewsletterFooter from "src/components/newsletterFooter"
import FooterBlobs from "../images/FooterBlobs"
// import CookieBanner from "../cookieBanner/"

// Styles
import "./footer.scss"

// Links
const linkSections = [
  {
    title: "Yours for free",
    links: [
      {
        href: "/absence-policy-template/",
        label: "Staff absence template",
        trackCta: "FooterLinkAbsencePolicy",
      },
      {
        href: "/annual-leave-policy-template/",
        label: "Annual leave policy template",
        trackCta: "FooterLinkAnnualLeavePolicy",
      },
      {
        href: "/holiday-calculator/",
        label: "Holiday calculator",
        trackCta: "FooterLinkHolidayCalculator",
      },
    ],
  },
  {
    title: "Timetastic",
    links: [
      {
        href: "https://changelog.timetastic.co.uk/",
        label: "What's new?",
        trackCta: "FooterLinkChangeLog",
      },
      {
        href: "https://timetastic.co.uk/api/",
        label: "API",
        trackCta: "FooterLinkApi",
      },
      {
        href: "/features",
        label: "Features",
        trackCta: "FooterLinkFeatures",
      },
      {
        href: "https://timetastic.getrewardful.com/signup",
        label: "Affiliate program",
        trackCta: "FooterAffiliate",
      },
      {
        href: "https://status.timetastic.co.uk/",
        label: "System status",
        trackCta: "FooterLinkStatusPage",
      },
    ],
  },
  {
    title: "Legal",
    links: [
      {
        href: "/legal/",
        label: "Terms and security",
        trackCta: "TermsAndSecurity",
      },
      {
        href: "/legal/cookie-policy/",
        label: "Cookie policy",
        trackCta: "CookiePolicy",
      },
      {
        href: "/legal/privacy-policy/",
        label: "Privacy policy",
        trackCta: "PrivacyPolicy",
      },
      {
        href: "https://timetastic.co.uk/documents/Citation_Group_Modern_Slavery_Statement_May_2025.pdf",
        label: "Modern slavery statement",
        trackCta: "ModernSlaveryStatement",
      },
    ],
  },
]

const date = new Date()
const currentYear = date.getFullYear()

// JSX
const Footer = () => (
  <footer className="c-footer">
    {/* <CookieBanner /> */}
    <FooterBlobs blobType="footerBlobs">
      <div className="c-footer__grid">
        <nav>
          {linkSections.map((linkSection, index) => (
            <div key={`linkSection-${index}`}>
              <span className="c-footer__heading">{linkSection.title}</span>
              <ul className="c-footer-nav__ul" role="menu">
                {linkSection.links.map((link, index) => (
                  <li
                    className="c-footer-nav__li"
                    key={`linkx-${index}`}
                    role="none"
                  >
                    {link.href.startsWith("/") && (
                      <Link
                        activeClassName="is-active"
                        role="menuitem"
                        to={link.href}
                        onClick={() => {
                          trackCta(link.trackCta)
                        }}
                      >
                        {link.label}
                      </Link>
                    )}
                    {!link.href.startsWith("/") && (
                      <a
                        href={link.href}
                        rel="noopener"
                        role="menuitem"
                        target="_blank"
                        title="Opens in a new window"
                        onClick={() => {
                          trackCta(link.trackCta)
                        }}
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>

        <div className="c-footer__logos">
          <div className="c-footer__logos-flex">
            <div>
              <a
                href="https://directories.onepercentfortheplanet.org/profile/timetastic-ltd"
                onClick={() => {
                  trackCta("OnePercent")
                }}
                rel="nofollow noreferrer noopener"
              >
                <img
                  loading="lazy"
                  alt="1% for the Planet"
                  src="/images/footer/1-percent-logo.svg"
                  width="58px"
                  height="70px"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="c-footer__smallprint">
          <div className="c-footer__smallprint-flex c-footer__smallprint-copyright">
            <div>
              &copy; Copyright 2012-{currentYear} Timetastic Ltd. Company Reg
              No. 09236149
            </div>
          </div>
        </div>
      </div>
    </FooterBlobs>
  </footer>
)

export default Footer
